<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'StatisticsManage'
    };
</script>

<style lang="less" scoped>
</style>
